import { NewCustomerFormData } from '../atoms/reviewCustomer.primitives.atoms'
import {
  CustomerFormFieldsData,
  EMPTY_CUSTOMER_FORM_ADDRESS
} from 'Customer/components/CustomerFormFields'

export const mapAtomToFormData = (
  atom: NewCustomerFormData
): CustomerFormFieldsData => ({
  legalName: atom.legalName,
  contacts: atom.contacts,
  address: atom.address,
  // Contract extraction only proposes a billing address.
  shippingAddress: EMPTY_CUSTOMER_FORM_ADDRESS,
  isShippingSameAsBilling: false,
  taxStatus: atom.taxStatus,
  aliases: atom.aliases,
  label: atom.label,
  parentId: atom.parentId,
  taxRegistrations: atom.taxRegistrations,
  customProperties: atom.customProperties
})

export const mapFormDataToAtom = (
  data: CustomerFormFieldsData
): NewCustomerFormData => ({
  legalName: data.legalName,
  contacts: data.contacts,
  address: data.address,
  taxStatus: data.taxStatus,
  aliases: data.aliases,
  label: data.label,
  parentId: data.parentId,
  taxRegistrations: data.taxRegistrations,
  customProperties: data.customProperties
})
